import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { applications } from "@/data/applications";
import { useAppConnections } from "@/hooks/useAppConnections";

export function AppCatalogue() {
  const { isLoading } = useAppConnections();

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardHeader>
              <div className="h-4 bg-muted rounded w-3/4"></div>
              <div className="h-3 bg-muted rounded w-full"></div>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div className="h-3 bg-muted rounded"></div>
                <div className="h-3 bg-muted rounded"></div>
                <div className="h-10 bg-muted rounded"></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Categories */}
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold mb-4">Canaux de vente</h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {applications
              .filter(app => app.type === "sales_channel")
              .map((app) => {
                
                return (
                  <Card key={app.id} className="relative transition-all hover:shadow-md">
                    <CardHeader className="pb-3">
                      <div className="flex items-start justify-between">
                        <div className="flex items-center gap-3">
                          <div className="p-2 rounded-lg bg-primary/10">
                            <app.icon className="h-5 w-5 text-primary" />
                          </div>
                          <div>
                            <CardTitle className="text-base">{app.name}</CardTitle>
                          </div>
                        </div>
                        {app.price && (
                          <div className="text-right">
                            <div className="text-sm font-semibold">
                              ${app.price.monthly}/mois
                            </div>
                            {app.price.annual && (
                              <div className="text-xs text-muted-foreground">
                                ${app.price.annual}/an
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <CardDescription className="line-clamp-2">
                        {app.description}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="pt-0">
                      {app.features && (
                        <div className="mb-4">
                          <ul className="text-sm text-muted-foreground space-y-1">
                            {app.features.slice(0, 3).map((feature, index) => (
                              <li key={index} className="flex items-center gap-2">
                                <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
                                <span className="line-clamp-1">{feature}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      <Button className="w-full" variant="outline" disabled>
                        Bientôt disponible
                      </Button>
                      <NotifyMeButton channel={app.id} className="w-full mt-2" />
                    </CardContent>
                  </Card>
                );
              })}
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Fournisseurs de dropshipping</h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {applications
              .filter(app => app.type === "dropshipping")
              .map((app) => {
                
                return (
                  <Card key={app.id} className="relative transition-all hover:shadow-md">
                    <CardHeader className="pb-3">
                      <div className="flex items-start justify-between">
                        <div className="flex items-center gap-3">
                          <div className="p-2 rounded-lg bg-primary/10">
                            <app.icon className="h-5 w-5 text-primary" />
                          </div>
                          <div>
                            <CardTitle className="text-base">{app.name}</CardTitle>
                          </div>
                        </div>
                        {app.price && (
                          <div className="text-right">
                            <div className="text-sm font-semibold">
                              ${app.price.monthly}/mois
                            </div>
                            {app.price.annual && (
                              <div className="text-xs text-muted-foreground">
                                ${app.price.annual}/an
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <CardDescription className="line-clamp-2">
                        {app.description}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="pt-0">
                      {app.features && (
                        <div className="mb-4">
                          <ul className="text-sm text-muted-foreground space-y-1">
                            {app.features.slice(0, 3).map((feature, index) => (
                              <li key={index} className="flex items-center gap-2">
                                <div className="h-1.5 w-1.5 rounded-full bg-primary flex-shrink-0" />
                                <span className="line-clamp-1">{feature}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      <Button className="w-full" variant="outline" disabled>
                        Bientôt disponible
                      </Button>
                      <NotifyMeButton channel={app.id} className="w-full mt-2" />
                    </CardContent>
                  </Card>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}